'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { motion } from 'motion/react';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import { HERO_MOTION } from './motion';
import StatusDot from './StatusDot';
interface StateOverlayProps {
  title: string;
  body: string;
  waiting?: boolean;
  action?: React.ReactNode;
}
const OverlayPosition = styled(motion.div)(({
  theme
}) => ({
  position: 'absolute',
  inset: 0,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.sizes.spacing['07']
}));
const OverlayCard = styled(FlexColumn)(({
  theme
}) => ({
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.sizes.spacing['03'],
  maxWidth: '22rem',
  padding: `${theme.sizes.spacing['08']} ${theme.sizes.spacing['09']}`,
  borderRadius: theme.sizes.radius['2xl'],
  border: `${theme.sizes.borderWidth[1]} solid ${theme.colors.border.secondary}`,
  backgroundColor: theme.colors.surface.primary,
  boxShadow: theme.boxShadows[1]
}));
const StateOverlay: React.FC<StateOverlayProps> = t0 => {
  const $ = _c(17);
  const {
    title,
    body,
    waiting: t1,
    action
  } = t0;
  const waiting = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 1
    };
    t4 = {
      opacity: 0
    };
    t5 = {
      duration: HERO_MOTION.overlay.duration
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== waiting) {
    t6 = waiting && <StatusDot tone="waiting" pulsing={true} />;
    $[4] = waiting;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== title) {
    t7 = <Typography variant="heading-sm" sx={_temp2}>{title}</Typography>;
    $[6] = title;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <FlexRow sx={_temp}>{t6}{t7}</FlexRow>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== body) {
    t9 = <Typography variant="body-sm" sx={_temp3}>{body}</Typography>;
    $[11] = body;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== action || $[14] !== t8 || $[15] !== t9) {
    t10 = <OverlayPosition initial={t2} animate={t3} exit={t4} transition={t5}><OverlayCard>{t8}{t9}{action}</OverlayCard></OverlayPosition>;
    $[13] = action;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default StateOverlay;
function _temp(theme) {
  return {
    alignItems: "center",
    gap: theme.sizes.spacing["04"]
  };
}
function _temp2(theme_0) {
  return {
    color: theme_0.colors.text.primary
  };
}
function _temp3(theme_1) {
  return {
    color: theme_1.colors.text.tertiary
  };
}